export default import.meta.ROLLDOWN_FILE_URL_Vlmbzbg9LHRLbtY7FA2xLw